// extracted by mini-css-extract-plugin
export default {"image-type-selectors-wrapper":"image-type-selectors-wrapper__Wtx_w"};